import { Store } from '@ngxs/store';
import { ShowErrorNotification, TranslationId } from '@platform-frontend/util';
import { MSG_ACCOUNT_LINK_ACCOUNT_CONFLICT, MSG_ACCOUNT_LINK_ACCOUNT_MISMATCH } from '../notification-messages';
import { SignOutOnError } from '../session';
import { LinkAccountState } from './link-account.state';

export const BUILD_LINK_ACCOUNT_ERROR_MSG = (store: Store, msg: (vendor: string) => TranslationId): TranslationId => {
  const vendor = store.selectSnapshot(LinkAccountState.vendor);
  return vendor && vendor.length > 0 ? msg(vendor) : msg('the host page');
};

export const LINK_ACCOUNT_ERROR_HANDLERS = (store: Store): Record<string, unknown> => {
  return {
    LINK_ACCOUNT_CONFLICT: new SignOutOnError(
      new ShowErrorNotification(BUILD_LINK_ACCOUNT_ERROR_MSG(store, (vendor: string) => MSG_ACCOUNT_LINK_ACCOUNT_CONFLICT(vendor)))
    ),
    LINK_ACCOUNT_MISMATCH: new SignOutOnError(
      new ShowErrorNotification(BUILD_LINK_ACCOUNT_ERROR_MSG(store, (vendor: string) => MSG_ACCOUNT_LINK_ACCOUNT_MISMATCH(vendor))),
      true
    )
  };
};
